module.exports = __webpack_public_path__ + "media/images/mail_template/logo-9ba1f122553fc9a792757a6a723fa7af.png";